var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRetry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0c3.312 0 6 2.688 6 6s-2.688 6-6 6-6-2.688-6-6 2.688-6 6-6zM2.4 6.444C2.472 8.298 4.002 9.828 5.856 9.9a3.597 3.597 0 0 0 3.672-2.892.596.596 0 0 0-.588-.708.602.602 0 0 0-.588.48A2.398 2.398 0 0 1 5.52 8.652 2.386 2.386 0 0 1 3.648 6.78 2.4 2.4 0 0 1 6 3.9v1.074c0 .27.324.402.51.21L8.19 3.51a.297.297 0 0 0 0-.426L6.516 1.41A.304.304 0 0 0 6 1.626V2.7a3.606 3.606 0 0 0-3.6 3.744z",
    fill: "#426AFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRetry);
export default __webpack_public_path__ + "static/media/icon-retry.eb44b1e81cbcfa8ddf21584adeb76ecc.svg";
export { ForwardRef as ReactComponent };